// extracted by mini-css-extract-plugin
export default {"advantages":"Advantages_advantages__IOezn","item":"Advantages_item__eQVqT","buttons":"Advantages_buttons__v912c","button":"Advantages_button__uFmxN"};